import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { whatsappConfigurationAppEntryPoint as main } from '@jira/spa-apps__help-center-settings-messaging-apps/src/whatsappConfigurationAppEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { csmExperienceMessagingAppsWhatsappRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceMessagingAppsWhatsappRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceMessagingAppsWhatsappPageEntryPoint = createPageEntryPoint({
	main,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceMessagingAppsWhatsappRouteEntry: Route = createEntry(
	csmExperienceMessagingAppsWhatsappRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-experience-messaging-apps-whatsapp',
		layout: globalLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			if (!fg('csm_appification_standalone_navigation')) {
				return notFoundPageEntrypoint;
			}
			return fg('csm-omni-whatsapp-support')
				? csmExperienceMessagingAppsWhatsappPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [...getCustomerServiceL1NavigationResources(), ...getCsmExperiencesResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
